import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { hasInitialAppLoadState } from '@/routes/initial-app-load-state';
import { AdvisorLoginRouteLoader } from '@/pages/login/route-loader';
import { isAdvisorPublicAuthPath } from '@/pages/login/brandContext';
import { shouldSuppressAuthRouteLoader } from '@/routes/auth-loader-state';
import { InitialAppLoadPageLoader } from './initial-app-load-page-loader';
import { AdvisorRouteSkeleton } from './route-loading-skeleton';
import { useRouteLoadingShellMounted } from './route-loading-shell-context';

const isPortalRoute = (pathname: string): boolean => pathname.startsWith('/home');

export const RouteLoadingFallback: FC = () => {
  const location = useLocation();
  const routeLoadingShellMounted = useRouteLoadingShellMounted();

  if (isAdvisorPublicAuthPath(location.pathname)) {
    if (shouldSuppressAuthRouteLoader(location.state)) {
      return null;
    }

    return <AdvisorLoginRouteLoader />;
  }

  if (hasInitialAppLoadState(location.state) || !isPortalRoute(location.pathname)) {
    return <InitialAppLoadPageLoader />;
  }

  return (
    <AdvisorRouteSkeleton
      pathname={location.pathname}
      reserveAppShell={!routeLoadingShellMounted}
    />
  );
};
